/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2019, Zumper
 * @description similarListings
 */

import type { Values } from '@zcode/utility-types'
import { filterActions } from '@zumper/redux-ignore'
import type { Reducer } from 'redux'
import type { ExtractActions } from 'redux-actions'
import type * as actions from './actions'
import * as constants from './constants'
import rootReducer from './reducers'

type Actions = ExtractActions<Values<typeof actions>>

const filterActionsReducer: Reducer<any, Actions> = filterActions(
  rootReducer,
  Object.values(constants)
)

export default filterActionsReducer
